module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ded-title"
  }, [_c('b', [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('i', [_vm._v("I’ve been creating my entire life and there are so many people who’ve taught me, inspired me, and cheered me on along the way. I create because of you. Thank you to all my friends and family who have contributed to my stitching life. I’ve learned from you. And a special thank-you to my students; you are the brightest spot in my stitching world.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d7a6890","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/0004_ack.vue
// module id = 63
// module chunks = 0